// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"460":"84d4be56","920":"84d4be56"}[chunkId] + ".chunk.css";
};